import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import Icons from '@shared/components/core/images/Icons';
import { CommandType, commandTypesDisplay } from '@shared/constants/CommandValues';
import { MacroDisplayModel } from '@shared/models/deviceProfiles/MacroModel';
import { useTranslation } from 'react-i18next';

const getIconsForCommand = (commandType: CommandType) => {
    return commandTypesDisplay[commandType] || null;
};

export interface IMacroCommandPreviewProps {
    commands: MacroDisplayModel['commands'];
    iconSize?: number;
}

export default function MacroCommandPreview({ commands, ...restProps }: IMacroCommandPreviewProps) {
    const { t } = useTranslation();
    //Dedupe command types for icons
    const uniqueCommandTypesArray: CommandType[] = [...new Set(commands.map(({ commandType }) => commandType))];

    return (
        <IconContainer {...restProps}>
            {uniqueCommandTypesArray.map((c, i) => {
                const command = getIconsForCommand(c);
                return (
                    <Tooltip
                        title={t('common:input.toolTip', 'This uses inputs', { alt: command.alt })}
                        key={`mcPreview_${i}`}>
                        <IconHover>
                            <Icons name={command.icon} ariaLabel={command.alt} size={34} />
                        </IconHover>
                    </Tooltip>
                );
            })}
        </IconContainer>
    );
}

const IconContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    margin-right: auto;
    padding: 0.5rem 0;
    left: 1rem;
`;

const IconHover = styled.div``;
